import { Flex, Text } from "rebass/styled-components";
import { CategoryType } from "../../types";
import styles from "../../styles/postStyle";
import CustomLink from "../common/CustomLink";

interface Props {
  categories: CategoryType[];
  variant?: string;
}

function CategoriesBlock(props: Props) {
  const { categories, variant = "post" } = props;

  const style = styles.category[variant as keyof typeof styles.category];

  return (
    <Flex sx={{ flexWrap: "wrap", gap: "8px" }}>
      {categories.map((cat, key) => (
        <CustomLink href={cat?.uri || ""} key={key}>
          <Text as="p" sx={style}>
            {cat.name}
          </Text>
        </CustomLink>
      ))}
    </Flex>
  );
}

export default CategoriesBlock;
